<template >
  <div id="abc" style="background: url('/img/assets/BACKGROUND.jpg');">
  <div v-if="isScreenChoice==='generic' || isScreenChoice ==='undefined'">
   <div v-if="isCurrentStep==='personalInfoDigital'" class="stepper-wrapper" >
  <div class="stepper-item completed">
    <div class="step-counter" style="color:white">1</div>
    <!-- <div class="step-name">First</div> -->
  </div>
  <div class="stepper-item">
    <div class="step-counter">2</div>
    
  </div>
  <div class="stepper-item" >
    <div class="step-counter">3</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">4</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">5</div>
    
  </div>
<div class="stepper-item">
    <div class="step-counter">6</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">7</div>
    
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">8</div>
    
    
  </div>
   </div>
    <div v-if="isCurrentStep==='otpVerificationDigital'" class="stepper-wrapper">
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    <!-- <div class="step-name">First</div> -->
  </div>
  <div class="stepper-item completed">
    <div class="step-counter" style="color:white">2</div>
    <!-- <div class="step-name">Second</div> -->
  </div>
  <div class="stepper-item">
    <div class="step-counter">3</div>
    <!-- <div class="step-name">Third</div> -->
  </div>
  <div class="stepper-item">
    <div class="step-counter">4</div>
    <!-- <div class="step-name">Forth</div> -->
  </div>
  <div class="stepper-item">
    <div class="step-counter">5</div>
    <!-- <div class="step-name">Forth</div> -->
  </div>
<div class="stepper-item">
    <div class="step-counter">6</div>
    <!-- <div class="step-name">Forth</div> -->
  </div>
  <div class="stepper-item">
    <div class="step-counter">7</div>
    <!-- <div class="step-name">Forth</div> -->
  </div>
    <div class="stepper-item">
    <div class="step-counter">8</div>
    <!-- <div class="step-name">Forth</div> -->
  </div>
 





</div> 
<div v-if="isCurrentStep==='choice'" class="stepper-wrapper">
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    <!-- <div class="step-name">First</div> -->
  </div>
  <div class="stepper-item completed">
    <div class="step-counter" style="color:white"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
 
  <div class="stepper-item completed">
    <div class="step-counter" style="color:white">3</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">4</div>
    
  </div>
<div class="stepper-item">
    <div class="step-counter">5</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">6</div>
    
  </div>
   <div class="stepper-item">
    <div class="step-counter">7</div>
    
  </div>
   <div class="stepper-item">
    <div class="step-counter">8</div>
    
  </div>
  
</div> 
 <div v-if="isCurrentStep==='creditCard'" class="stepper-wrapper">
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    <!-- <div class="step-name">First</div> -->
  </div>
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed" >
    <div class="step-counter" style="color:white"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
 
  <div class="stepper-item completed">
    <div class="step-counter" style="color:white">4</div>
    
  </div>
<div class="stepper-item">
    <div class="step-counter">5</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">6</div>
    
  </div>
   <div class="stepper-item">
    <div class="step-counter">7</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">8</div>
    
  </div>
</div> 
 <div v-if="isCurrentStep==='loan'" class="stepper-wrapper">
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    <!-- <div class="step-name">First</div> -->
  </div>
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed" >
    <div class="step-counter" style="color:white"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
 
  <div class="stepper-item completed">
    <div class="step-counter" style="color:white">4</div>
    
  </div>
<div class="stepper-item">
    <div class="step-counter">5</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">6</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">7</div>
    
  </div>
   <div class="stepper-item">
    <div class="step-counter">8</div>
    
  </div>
        </div>
        <div v-if="isCurrentStep==='uploadIdentityDigital'" class="stepper-wrapper">
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    <!-- <div class="step-name">First</div> -->
  </div>
  <div class="stepper-item completed">
    <div class="step-counter" ><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
 
<div class="stepper-item completed">
    <div class="step-counter" style="color:white">5</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">6</div>
    
  </div>
   <div class="stepper-item">
    <div class="step-counter">7</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">8</div>
    
  </div>
</div>
 <div v-if="isCurrentStep==='identityReviewDigital'" class="stepper-wrapper">
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    <!-- <div class="step-name">First</div> -->
  </div>
  <div class="stepper-item completed">
    <div class="step-counter" ><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed" >
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>

  <div class="stepper-item completed">
    <div class="step-counter" style="color:white">6</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">7</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">8</div>
    
  </div>
</div>
<div v-if="isCurrentStep==='employmentDetailsDigital'" class="stepper-wrapper">
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    <!-- <div class="step-name">First</div> -->
  </div>
  <div class="stepper-item completed">
    <div class="step-counter" ><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed" >
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed">
    <div class="step-counter" ><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
<div class="stepper-item completed" >
    <div class="step-counter" ><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
    <div class="stepper-item completed">
    <div class="step-counter" style="color:white">7</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">8</div>
    
  </div>
</div>
  <div v-if="isCurrentStep==='insuranceDigital'" class="stepper-wrapper">
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    <!-- <div class="step-name">First</div> -->
  </div>
  <div class="stepper-item completed">
    <div class="step-counter" ><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed" >
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed">
    <div class="step-counter" ><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
<div class="stepper-item completed" >
    <div class="step-counter" style="color:white"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed">
    <div class="step-counter" style="color:white"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>

  <div class="stepper-item completed">
    <div class="step-counter" style="color:white">8</div>
    
  </div>
  
</div>
</div>
<!-- Screen Choice loan or card -->
 <div v-if="isScreenChoice==='card' || isScreenChoice==='loan' ">
   <div v-if="isCurrentStep==='personalInfoDigital'" class="stepper-wrapper" >
  <div class="stepper-item completed">
    <div class="step-counter" style="color:white">1</div>
    <!-- <div class="step-name">First</div> -->
  </div>
  <div class="stepper-item">
    <div class="step-counter">2</div>
    
  </div>
  <div class="stepper-item" >
    <div class="step-counter">3</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">4</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">5</div>
    
  </div>
<div class="stepper-item">
    <div class="step-counter">6</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">7</div>
    
    
  </div>
  
   </div>
    <div v-if="isCurrentStep==='otpVerificationDigital'" class="stepper-wrapper">
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    <!-- <div class="step-name">First</div> -->
  </div>
  <div class="stepper-item completed">
    <div class="step-counter" style="color:white">2</div>
    <!-- <div class="step-name">Second</div> -->
  </div>
  <div class="stepper-item">
    <div class="step-counter">3</div>
    <!-- <div class="step-name">Third</div> -->
  </div>
  <div class="stepper-item">
    <div class="step-counter">4</div>
    <!-- <div class="step-name">Forth</div> -->
  </div>
  <div class="stepper-item">
    <div class="step-counter">5</div>
    <!-- <div class="step-name">Forth</div> -->
  </div>
<div class="stepper-item">
    <div class="step-counter">6</div>
    <!-- <div class="step-name">Forth</div> -->
  </div>
  <div class="stepper-item">
    <div class="step-counter">7</div>
    <!-- <div class="step-name">Forth</div> -->
  </div>
    


</div> 
 
 <div v-if="isCurrentStep==='creditCard'" class="stepper-wrapper">
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    <!-- <div class="step-name">First</div> -->
  </div>
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
 
 
  <div class="stepper-item completed">
    <div class="step-counter" style="color:white">3</div>
    
  </div>
<div class="stepper-item">
    <div class="step-counter">4</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">5</div>
    
  </div>
   <div class="stepper-item">
    <div class="step-counter">6</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">7</div>
    
  </div>
</div> 
 <div v-if="isCurrentStep==='loan'" class="stepper-wrapper">
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    <!-- <div class="step-name">First</div> -->
  </div>
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
 
 
  <div class="stepper-item completed">
    <div class="step-counter" style="color:white">3</div>
    
  </div>
<div class="stepper-item">
    <div class="step-counter">4</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">5</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">6</div>
    
  </div>
   <div class="stepper-item">
    <div class="step-counter">7</div>
    
  </div>
        </div>
        <div v-if="isCurrentStep==='uploadIdentityDigital'" class="stepper-wrapper">
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    <!-- <div class="step-name">First</div> -->
  </div>
  <div class="stepper-item completed">
    <div class="step-counter" ><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
 
<div class="stepper-item completed">
    <div class="step-counter" style="color:white">4</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">5</div>
    
  </div>
   <div class="stepper-item">
    <div class="step-counter">6</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">7</div>
    
  </div>
</div>
 <div v-if="isCurrentStep==='identityReviewDigital'" class="stepper-wrapper">
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    <!-- <div class="step-name">First</div> -->
  </div>
  <div class="stepper-item completed">
    <div class="step-counter" ><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed" >
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed">
    <div class="step-counter" style="color:white">5</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">6</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">7</div>
    
  </div>
</div>
<div v-if="isCurrentStep==='employmentDetailsDigital'" class="stepper-wrapper">
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    <!-- <div class="step-name">First</div> -->
  </div>
  <div class="stepper-item completed">
    <div class="step-counter" ><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed" >
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed">
    <div class="step-counter" ><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>

    <div class="stepper-item completed">
    <div class="step-counter" style="color:white">6</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">7</div>
    
  </div>
</div>
  <div v-if="isCurrentStep==='insuranceDigital'" class="stepper-wrapper">
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    <!-- <div class="step-name">First</div> -->
  </div>
  <div class="stepper-item completed">
    <div class="step-counter" ><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed" >
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
  <div class="stepper-item completed">
    <div class="step-counter" ><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
<div class="stepper-item completed" >
    <div class="step-counter" style="color:white"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
    
  </div>
 

  <div class="stepper-item completed">
    <div class="step-counter" style="color:white">7</div>
    
  </div>
  
</div>
 </div>
    <MainForm
      :name="FORM_NAMES.onboardingDigital"
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :ui-form="uiForm"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPageDigital"
      ui-title=""
    >
    <StepModel :ui="uiBaseStep" 
    :name="STEP_NAMES.personalInfoDigital" ui-title="Personal Info" ui-subtitle="" ui-button-text="Submit" >
        <!-- <FieldsetModel
          :ui="uiBaseFieldset"
          name="fieldsetLoanImage"
          ui-title=""
          ui-columns="2"
        >
          <UiWrapper name="FIELD_NAMES.Card">
            <Card
              title=""
              background-color=""
              background-image="/img/assets/loans/loan_snap.png"
            >
             
              <template slot="cta"></template>
            </Card>
          </UiWrapper>
        </FieldsetModel> -->
          <!-- <FieldsetModel :ui="uiBaseFieldset" name="fieldSetStep1" ui-title="" >
       
      </FieldsetModel> -->
        <!-- <FieldsetModel
          :ui="uiBaseFieldset"
          name="fieldsetCardImage"
          ui-title=""
          ui-columns="2"
        >
        

             
              <p class="choiceTitle1" style="padding-bottom:30px;text-align:center"> Get a Credit Card that suits your lifestyle<img src="/img/assets/card/3cards.jpg" width="300px" height="170px"  /></p>
              
        </FieldsetModel> -->
        <FieldsetFullName :fieldset-name="FIELDSET_NAMES.fullNameReview" />
        <FieldsetMobilePhone title="Mobile number" subtitle="" />
        <FieldsetEmail title="Email ID" subtitle="" />
        
        <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.fixedIncomeFieldset"
          ui-title="Monthly Fixed Income"
        >
          <FieldIncome
            :name="FIELD_NAMES.fixedIncome"
            label="Monthly Fixed Income"
          />
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          name="fieldSetFirstStepTitle"
          ui-title="By clicking 'SUBMIT' you consent to us contacting you to follow up on your application"
        >
        </FieldsetModel>
      </StepModel>
      <!-- <StepModel
        :ui="uiBaseStep"
        :name="STEP_NAMES.continue"
        ui-title=" "
        ui-subtitle=" "
        ui-hide-button
      >
         <FieldsetModel :ui="uiBaseFieldset" name="fieldSetStep2" ui-title="" >
        <div class="stepper-wrapper">
  <div class="stepper-item completed">
    <div class="step-counter"><i class="material-icons" style="font-size:20px;color:white">done</i></div>
  </div>
  <div class="stepper-item completed">
    <div class="step-counter" style="color:white">2</div>
    
  </div>
  <div class="stepper-item" >
    <div class="step-counter" style="color:white">3</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">4</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">5</div>
    
  </div>
<div class="stepper-item">
    <div class="step-counter">6</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">7</div>
    
  </div>
  <div class="stepper-item">
    <div class="step-counter">8</div>
    
    
  </div>
   <div class="stepper-item">
    <div class="step-counter">9</div>
    
    
  </div>
  
        </div>
      </FieldsetModel>
        <FieldsetModel :ui="uiBaseFieldset" name="fieldSetContinue" ui-title="">
          
          <p class="p1">Awesome !</p>

          <p class="p2">
            {{ this.firstTitle + this.mobileNumber }}
          </p>
           <p class="p3">
          
          <button class="buttonClass" id="linkButton" @click.prevent="moveToSecondStep">
           Continue Application
          </button>
          
        </p>
           
        </FieldsetModel>
   
      </StepModel> -->
      <StepOtp
        :change-phone-action="goToStep(STEP_NAMES.eligibility)"
      />
      <div v-if="isScreenChoice==='generic'">
        <StepModel
        :ui="uiBaseStep"
        :name="STEP_NAMES.choice"
        ui-title=" "
        ui-subtitle=" "
        ui-hide-button
      >
      <!-- <FieldsetModel :ui="uiBaseFieldset" name="fieldSetStep4" ui-title="" >
        
      </FieldsetModel> -->
        <FieldsetModel :ui="uiBaseFieldset" name="fieldsetChoice" ui-title="">
         
          <div class="container">
            <div class="step2-col1">
              <p class="choiceTitle1">Get a Credit Card that suits your lifestyle</p>
              <p style="padding-bottom:160px;"><img src="/img/assets/card/3cards.jpg" width="300px" height="170px"  /></p>
              <p style="padding-bottom:20px">
                <button
                  class="buttonClass2"
                  
                  id="linkButton"
                  @click.prevent="liked('Credit Card')"
                >
                  I’D LIKE A CARD
                </button>
              </p>
            </div>
            <div class="step2-col2">
              <p class="choiceTitle1">Get a Deem Personal Loan at affordable instalments</p>
              <p style="padding-bottom:30px;"><img src="/img/assets/loans/family2.jpg" width="300px" height="300px" /></p>
              <p>
                <button
                  class="buttonClass2"
                  id="linkButton"
                  @click.prevent="liked('Personal_Loan')"
                >
                  I’D LIKE A LOAN
                </button>
              </p>
            </div>
          </div>
         
        </FieldsetModel>
      </StepModel>

      </div>
      <div v-if="isScreenChoice==='card' || isScreenChoice==='generic'" >
        <StepModel
        :ui="uiBaseStep"
        :name="STEP_NAMES.creditCard"
        ui-title=" "
        ui-subtitle=" "
        ui-hide-button
      >
       <!-- <FieldsetModel :ui="uiBaseFieldset" name="fieldSetStep5" ui-title="" >
       
      </FieldsetModel> -->
        <div v-if="isMonthlyIncomeSource>25000 && viewMore===true">
        <FieldsetModel :ui="uiBaseFieldset" name="fieldsetWorldChoice1" ui-title=""  >
          <div class="container">
            <div class="step3-col1" >
              <p class="choiceTitle1">Based on the information, we recommend World Cash Up Card</p>
              <p style="padding-bottom:30px;"><img src="/img/assets/card/World - Cash Up.png" width="250px" height="150px" /></p>
                
                 <!-- <p style="padding-bottom:20px;font-weight: bold; display:inline-block;margin-right:10px;"  >Key benefits:
            
              </p> -->
              <div style="padding-bottom:20px;">
                <div style="font-weight: bold; display:inline-block;margin-right:10px;">Key benefits: </div>
              
                <div class="pointer"  style="font-weight: bold; display:inline-block;margin-right:10px;"><img  @click.prevent="keyBenifitsWorld=!keyBenifitsWorld" src="/img/assets/icons/sliderDown.png" width="15px" height="15px" alt="" /> </div>
              </div>
              
              <p v-if="keyBenifitsWorld" style="padding-bottom:30px;">
               <span style="padding-bottom:10px">World Cash Up:</span>  

                <ul class="dashed">
                  <li>Up to 10% Cash Up on Airlines, Entertainment and Hotels</li>
                  <li>Buy 1 Get 1 offers on dining, wellness and entertainment experiences at over 500 merchants</li>
                  <li>Complementary Valet Parking services</li>
                  <li>Access to 1,000 airport lounges around the world</li>
                </ul>
              </p>
              <p style="padding-bottom:20px">
                <button
                  class="buttonClass2"
                  
                  id="linkButton"
                  @click.prevent="apply('World Cash Up')"
                >
                  APPLY NOW
                </button>
              </p>
           <p class="text-decoration" @click.prevent="viewMoreCard()" style="padding-bottom:20px">
                View more cards
              </p>
            </div>
          </div>
        </FieldsetModel>
        </div>
      <div v-if="isMonthlyIncomeSource>25000 && viewMore===false">

        <FieldsetModel :ui="uiBaseFieldset" name="fieldsetWorldChoice2" ui-title=""  >
          <p class="p1" style="text-align:left; padding-bottom:30px">Our other Cash Up Cards. Choose the one that best suits your needs.</p>
          <div class="container">
            <div class="step3-col1" >
              <p class="choiceTitle1">World Cash Up</p>
              <p style="padding-bottom:30px;"><img src="/img/assets/card/World - Cash Up.png" width="250px" height="150px" /></p>
                
                 <!-- <p style="padding-bottom:20px;font-weight: bold; display:inline-block;margin-right:10px;"  >Key benefits:
            
              </p> -->
              <div style="padding-bottom:20px;">
                <div style="font-weight: bold; display:inline-block;margin-right:10px;">Key benefits: </div>
              
                <div class="pointer"  style="font-weight: bold; display:inline-block;margin-right:10px;"><img  @click.prevent="keyBenifitsWorld=!keyBenifitsWorld" src="/img/assets/icons/sliderDown.png" width="15px" height="15px" alt="" /> </div>
              </div>
              
              <p v-if="keyBenifitsWorld" style="padding-bottom:30px;">
               <span style="padding-bottom:10px">World Cash Up:</span>  

                <ul class="dashed">
                  <li>Up to 10% Cash Up on Airlines, Entertainment and Hotels</li>
                  <li>Buy 1 Get 1 offers on dining, wellness and entertainment experiences at over 500 merchants</li>
                  <li>Complementary Valet Parking services</li>
                  <li>Access to 1,000 airport lounges around the world</li>
                </ul>
              </p>
              <p style="padding-bottom:20px">
                <button
                  class="buttonClass2"
                  
                  id="linkButton"
                  @click.prevent="apply('World Cash Up')"
                >
                  APPLY NOW
                </button>
              </p>
             <p class="text-decoration" @click.prevent="viewLessCard()" style="padding-bottom:20px">
                View less
              </p>
            </div>
            <div class="step3-col2">
              <p class="choiceTitle1">Platinum Cash Up</p>
              <p style="padding-bottom:30px;"><img src="/img/assets/card/Platinum - Cash Up.png" width="250px" height="150px" /></p>
               <div style="padding-bottom:20px;">
                <div style="font-weight: bold; display:inline-block;margin-right:10px;">Key benefits: </div>
              
                <div class="pointer"  style="font-weight: bold; display:inline-block;margin-right:10px;"><img  @click.prevent="keyBenifitsPlatinum=!keyBenifitsPlatinum" src="/img/assets/icons/sliderDown.png" width="15px" height="15px" alt="" /> </div>
              </div>
              <p v-if="keyBenifitsPlatinum" style="padding-bottom:30px;">
                <span style="padding-bottom:10px">Platinum Cash Up:</span>  
                <ul class="dashed">
                  <li>Free for Life</li>
                  <li>Up to 10% Cash Up at Department stores</li>
                  <li>Up to 5% Cash Up on Online shopping and Entertainment</li>
                  <li>Buy 1 Get 1 offers on dining, wellness and entertainment experiences at over 400 merchants
                  </li>
                  <li>Complementary Valet Parking services
                  </li>
                </ul>
              </p>
              <p style="padding-bottom:20px">
                <button
                  class="buttonClass2"
                  id="linkButton"
                  @click.prevent="apply('Platinum Cash Up')"
                >
                  APPLY NOW
                </button>
              </p>
               <p class="text-decoration" @click.prevent="viewLessCard()" style="padding-bottom:20px">
                View less
              </p>
            </div>
             <div class="step3-col3">
              <p class="choiceTitle1">Titanium Cash Up</p>
              <p style="padding-bottom:30px;"><img src="/img/assets/card/Titanium - Cash Up.png" width="250px" height="150px" /></p>
               <div style="padding-bottom:20px;">
                <div style="font-weight: bold; display:inline-block;margin-right:10px;">Key benefits: </div>
              
                <div class="pointer"  style="font-weight: bold; display:inline-block;margin-right:10px;"><img  @click.prevent="keyBenifitsTitanium=!keyBenifitsTitanium" src="/img/assets/icons/sliderDown.png" width="15px" height="15px" alt="" /> </div>
              </div>
              <p v-if="keyBenifitsTitanium" style="padding-bottom:30px">
                 <span style="padding-bottom:10px">Titanium Cash Up:</span> 
                <ul class="dashed">
                  <li>Free for the 1st year</li>
                  <li>Flat 3% Cash Up on fuel</li>
                  <li>Up to 3% Cash Up at Supermarkets and Utilities</li>
                  <li>Buy 1 Get 1 offers on dining, wellness and entertainment experiences at over 400 merchants</li>
                </ul>
              </p>
              <p style="padding-bottom:20px">
                <button
                  class="buttonClass2"
                  id="linkButton"
                  @click.prevent="apply('Titanium Cash Up')"
                >
                 APPLY NOW
                </button>
              </p>
              <p class="text-decoration" @click.prevent="viewLessCard()" style="padding-bottom:20px">
                View less
              </p>
              
            </div>
           
          </div>
         
        </FieldsetModel>
        </div>
                <div v-if="(isMonthlyIncomeSource>=10000 && isMonthlyIncomeSource<=25000) && viewMore===true">
        <FieldsetModel :ui="uiBaseFieldset" name="fieldsetPlatinumChoice1" ui-title="" >
         
          <div class="container">
          
            <div class="step3-col1">
              <p class="choiceTitle1">Based on the information, we recommend Platinum Cash Up Card</p>
              <p style="padding-bottom:30px;"><img src="/img/assets/card/Platinum - Cash Up.png" width="250px" height="150px" /></p>
             
             <div style="padding-bottom:20px;">
                <div style="font-weight: bold; display:inline-block;margin-right:10px;">Key benefits: </div>
              
                <div class="pointer"  style="font-weight: bold; display:inline-block;margin-right:10px;"><img  @click.prevent="keyBenifitsPlatinum=!keyBenifitsPlatinum" src="/img/assets/icons/sliderDown.png" width="15px" height="15px" alt="" /> </div>
              </div>
              <p v-if="keyBenifitsPlatinum" style="padding-bottom:30px;">
                <span style="padding-bottom:10px">Platinum Cash Up:</span>  
                <ul class="dashed">
                  <li>Free for Life</li>
                  <li>Up to 10% Cash Up at Department stores</li>
                  <li>Up to 5% Cash Up on Online shopping and Entertainment</li>
                  <li>Buy 1 Get 1 offers on dining, wellness and entertainment experiences at over 400 merchants
                  </li>
                  <li>Complementary Valet Parking services
                  </li>
                </ul>
              </p>
               <p style="padding-bottom:20px">
                <button
                  class="buttonClass2"
                  id="linkButton"
                  @click.prevent="apply('Platinum Cash Up')"
                >
                  APPLY NOW
                </button>
              </p>
              <p class="text-decoration" @click.prevent="viewMoreCard()" style="padding-bottom:20px">
                View more cards
              </p>
            </div>

          </div>
        </FieldsetModel>
                </div>
         <div v-if="(isMonthlyIncomeSource>=10000 && isMonthlyIncomeSource<=25000) && viewMore===false">
        <FieldsetModel :ui="uiBaseFieldset" name="fieldsetPlatinumChoice2" ui-title="" >
          <p class="p1" style="text-align:left; padding-bottom:30px">Our other Cash Up Cards. Choose the one that best suits your needs.</p>
          <div class="container">
          
            <div class="step3-col1">
              <p class="choiceTitle1">Deem Platinum Cash Up Credit Card</p>
              <p style="padding-bottom:30px;"><img src="/img/assets/card/Platinum - Cash Up.png" width="250px" height="150px" /></p>
             <div style="padding-bottom:20px;">
                <div style="font-weight: bold; display:inline-block;margin-right:10px;">Key benefits: </div>
              
                <div class="pointer"  style="font-weight: bold; display:inline-block;margin-right:10px;"><img  @click.prevent="keyBenifitsPlatinum=!keyBenifitsPlatinum" src="/img/assets/icons/sliderDown.png" width="15px" height="15px" alt="" /> </div>
              </div>
              <p v-if="keyBenifitsPlatinum" style="padding-bottom:30px;">
                <span style="padding-bottom:10px">Platinum Cash Up:</span>  
                <ul class="dashed">
                  <li>Free for Life</li>
                  <li>Up to 10% Cash Up at Department stores</li>
                  <li>Up to 5% Cash Up on Online shopping and Entertainment</li>
                  <li>Buy 1 Get 1 offers on dining, wellness and entertainment experiences at over 400 merchants
                  </li>
                  <li>Complementary Valet Parking services
                  </li>
                </ul>
              </p>
              <p style="padding-bottom:20px">
                <button
                  class="buttonClass2"
                  id="linkButton"
                  @click.prevent="apply('Platinum Cash Up')"
                >
                  APPLY NOW
                </button>
              </p>
               <p class="text-decoration" @click.prevent="viewLessCard()" style="padding-bottom:20px">
                View less
              </p>
            </div>
             <div class="step3-col2">
              <p class="choiceTitle1">Deem Titanium Cash Up Credit Card</p>
              <p style="padding-bottom:30px;"><img src="/img/assets/card/Titanium - Cash Up.png" width="250px" height="150px" /></p>
               <div style="padding-bottom:20px;">
                <div style="font-weight: bold; display:inline-block;margin-right:10px;">Key benefits: </div>
              
                <div class="pointer"  style="font-weight: bold; display:inline-block;margin-right:10px;"><img  @click.prevent="keyBenifitsTitanium=!keyBenifitsTitanium" src="/img/assets/icons/sliderDown.png" width="15px" height="15px" alt="" /> </div>
              </div>
              <p v-if="keyBenifitsTitanium" style="padding-bottom:30px">
                 <span style="padding-bottom:10px">Titanium Cash Up:</span> 
                <ul class="dashed">
                  <li>Free for the 1st year</li>
                  <li>Flat 3% Cash Up on fuel</li>
                  <li>Up to 3% Cash Up at Supermarkets and Utilities</li>
                  <li>Buy 1 Get 1 offers on dining, wellness and entertainment experiences at over 400 merchants</li>
                </ul>
              </p>
              <p style="padding-bottom:20px">
                <button
                  class="buttonClass2"
                  id="linkButton"
                  @click.prevent="apply('Titanium Cash Up')"
                >
                 APPLY NOW
                </button>
              </p>
              <p class="text-decoration" @click.prevent="viewLessCard()" style="padding-bottom:20px">
                View less
              </p>
            </div>
          </div>
         
        </FieldsetModel>
         </div>
          <div v-if="isMonthlyIncomeSource==5000">
         <FieldsetModel :ui="uiBaseFieldset" name="fieldsetTitaniumhoice" ui-title="" >
          <div class="container">
             <div class="step3-col1">
              <p class="choiceTitle1">Based on the information, we recommend Titanium Cash Up Card</p>
              <p style="padding-bottom:30px;"><img src="/img/assets/card/Titanium - Cash Up.png" width="250px" height="150px" /></p>
               <div style="padding-bottom:20px;">
                <div style="font-weight: bold; display:inline-block;margin-right:10px;">Key benefits: </div>
              
                <div class="pointer"  style="font-weight: bold; display:inline-block;margin-right:10px;"><img  @click.prevent="keyBenifitsTitanium=!keyBenifitsTitanium" src="/img/assets/icons/sliderDown.png" width="15px" height="15px" alt="" /> </div>
              </div>
              <p v-if="keyBenifitsTitanium" style="padding-bottom:30px">
                 <span style="padding-bottom:10px">Titanium Cash Up:</span> 
                <ul class="dashed">
                  <li>Free for the 1st year</li>
                  <li>Flat 3% Cash Up on fuel</li>
                  <li>Up to 3% Cash Up at Supermarkets and Utilities</li>
                  <li>Buy 1 Get 1 offers on dining, wellness and entertainment experiences at over 400 merchants</li>
                </ul>
              </p>
              <p style="padding-bottom:20px">
                <button
                  class="buttonClass2"
                  id="linkButton"
                  @click.prevent="apply('Titanium Cash Up')"
                >
                 APPLY NOW
                </button>
              </p>
            </div>
          </div>
        </FieldsetModel>
          </div>
           <!-- <FieldsetModel :ui="uiBaseFieldset" :name="FIELDSET_NAMES.customerConsent">
        

        <p hidden class="saving" id="spinner">
          <span class="dot"></span>
          <span class="dotText">Give us few seconds...</span>
        </p>
      </FieldsetModel> -->
      </StepModel>
      </div>
      <div v-if="isScreenChoice==='loan' ||  isScreenChoice==='generic'">
         <StepModel :ui="uiBaseStep" :name="STEP_NAMES.loan" ui-title=" " ui-subtitle=" ">
        <!-- <FieldsetModel
          :ui="uiBaseFieldset"
          name="fieldsetLoanImage"
          ui-title=""
          ui-columns="2"
        >
          <UiWrapper name="FIELD_NAMES.Card">
            <Card
              title=""
              background-color=""
              background-image="/img/assets/loans/loan_snap.png"
            >
             
              <template slot="cta"></template>
            </Card>
          </UiWrapper>
        </FieldsetModel> -->
          <!-- <FieldsetModel :ui="uiBaseFieldset" name="fieldSetStep6" ui-title="" >
       
      </FieldsetModel> -->
        <FieldsetModel
          :ui="uiBaseFieldset"
          name="fieldsetLoanImage"
          ui-title=""
          ui-columns="2"
        >
         <!-- <div class="step2-col2"> -->
             
              <p class="choiceTitle1" style="padding-bottom:30px;"> Deem Personal Loan<img src="/img/assets/loans/family2.jpg" width="300px" height="300px" /></p>
               <!-- <p class="choiceTitle1" >Get a Deem Personal Loan at affordable instalments</p> -->
            <!-- </div> -->
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          name="howmuch"
          ui-title="How much do you need to borrow?"
        >
          <FieldIncome
            :name="FIELD_NAMES.howmuch"
            label="Enter any amount, in AED (e.g. 5000)"
          />
        </FieldsetModel>
        <FieldsetModel
          :ui="uiBaseFieldset"
          name="instalments"
          ui-title="In how many instalments would you like to repay?"
        >
          <UiWrapper
            :ui="uiBaseField"
            :name="FIELD_NAMES.instalments"
            :default-value="4"
          >
            <InputSlide
              :min="1"
              :max="4"
              :suffix="suffixSingularPlural(FIELD_NAMES.instalments, ' year')"
            />
          </UiWrapper>
        </FieldsetModel>
      </StepModel>
      </div>
      
      <StepOCREmirates :subTitle="`Upload a picture of your Emirates ID (Front & Back) from your phone or laptop and click Submit`" />
        <IdentityReview/>
      <!-- <StepOtp
        :change-phone-action="goToStep(STEP_NAMES.eligibility)"
      /> -->

      <StepModel
        :ui="uiBaseStep"
        :name="STEP_NAMES.employmentDetailsDigital"
        ui-title=""
        ui-subtitle=""
        ui-error-message="Please review the fields marked in red"
        ui-button-text="Submit"
      >
      <!-- <FieldsetModel :ui="uiBaseFieldset" name="fieldSetStep9" ui-title="" >
        
      </FieldsetModel> -->

      <FieldsetModel :ui="uiBaseFieldset" name="fieldSetEmploymentDigital" >
      <p style=" color: #6e3dea;
  font-weight: 500;
  font-size: 30px;padding-bottom:10px">Tell us a bit about your work</p>
  <p style="font-weight: 500;font-size: 15px">Perfect! Tell us about your work</p>
  </FieldsetModel>
      <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.employmentDetailsType"
          ui-title="Your current employment status is:"
          ui-subtitle=""
        >
          <UiWrapper :name="FIELD_NAMES.employmentType">
            <Choice
              :options="[
                {
                  value: 'Salaried',
                  label: 'Working for a company',
                },
                {
                  value: 'Self-employed',
                  label: 'Self employed',
                },
              ]"
            />
          </UiWrapper>
        </FieldsetModel>
         <FieldsetModel
         
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.workInformationSalaried"
          ui-title="What is your employer's name is:"
          :presence="isSalaried"
          ui-subtitle="*Please ensure you enter the company name as per your visa"
        >
          <UiWrapper
            :name="FIELD_NAMES.companyName"
            label="Company Name"
            :validations="[
              {
                errorMessage: 'This field must not be empty',
                condition: notEmptyCondition,
                name: 'companies-filled',
              },
            ]"
          >
            <Suggest
              data-forced-fullwidth="true"
              :exact-match="false"
              placeholder="Type the name of your company"
              :get-formatted-item="formatMatchedString"
              :get-suggestions="getCompanies"
            />
          </UiWrapper>
          <UiWrapper :name="FIELD_NAMES.areaOfWork">
            <Dropdown
              placeholder="Company Emirate"
              :options="EMIRATE_LIST_CARD"
            />
          </UiWrapper>
         </FieldsetModel>
         <FieldsetModel
          :presence="isSelfEmployed"
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.workInformationSelfEmployed"
          ui-title="Details of employment"
          ui-columns="2"
        >
          <UiWrapper
            :name="FIELD_NAMES.companyNameSelfEmployed"
            label="Type the name of your company"
          >
            <InputText />
          </UiWrapper>
           <UiWrapper :name="FIELD_NAMES.areaOfWork">
            <Dropdown
              placeholder="Company Emirate"
              :options="EMIRATE_LIST_CARD"
            />
           </UiWrapper>
         </FieldsetModel>
          <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.employmentType"
          ui-title="What is your work email address?"
         
        >
          <UiWrapper
            :name="FIELD_NAMES.workEmail"
            label="Email ID"
            :validations="[
              {
                errorMessage: 'Please type a valid email',
                condition: patternCondition(EMAIL_VALIDATION_PATTERN),
                name: 'check-is-email',
              },
            ]"
          >
            <InputText />
          </UiWrapper>
        </FieldsetModel>
          <FieldsetIBAN title="Please enter the IBAN number of your salary account so that your salary can be verified" />
      </StepModel>
       <StepModel
        :ui="uiBaseStep"
        :name="STEP_NAMES.insuranceDigital"
        ui-title=" "
        ui-subtitle=" "
        ui-hide-button
      >
      <!-- <FieldsetModel :ui="uiBaseFieldset" name="fieldSetStep10" ui-title="" >
      
      </FieldsetModel> -->
      <div v-if="appiontmentText==='Credit Card' || isScreenChoice==='card'">
 <FieldsetModel :ui="uiBaseFieldset" name="fieldsetInsuranceCard" ui-title="">
          <div class="container">
            <div class="step2-col1 margin-top" style="max-width:400px;" >
              <p class="p1-insurance">Insure your Credit  Card & be Sure</p> 
             <p class="p2-insurance">To opt in for one or both the insurance please click on the box and hit "SUBMIT"</p>
              <!-- <p class="p1-insurance">Insure your Credit  Card & be Sure</p>
              
             <p class="p2-insurance">To opt in for one or both the insurance please click on the box and hit "SUBMIT"</p> -->
            </div>
            <div class="step2-col2" style="max-width:400px" >
         <p style="font-weight:bold;padding-bottom:20px;display:inline-block;margin-right:10px;">Deem Double Secure</p>
             <input type="checkbox" class="largerCheckbox" id="chkDoubleSecure" name="chkDoubleSecure" @change.prevent="doubleSecure($event)" style="margin-top: 5px; color: #6E3DEA;margin-left: 5%;">
             <p style="display:inline-block;padding-bottom:20px">The plans covers your credit card outstanding in the event of involuntary loss of employment.
                It pays double in the unfortunate event of critical illness or accidental death and also extends 
                benifits like Ambulance/Taxi Fare & per day hospital cash payouts. All this for a nominal fee. Click here to know more.

             </p>
             <p style="padding-bottom:50px;color:#9E9E9E">View Fees & Charges ></p>
<p style="font-weight:bold;padding-bottom:20px;display:inline-block;margin-right:10px;">Deem Guard</p>
 <input type="checkbox" class="largerCheckbox" id="chkGuard" name="chkGuard" @change.prevent="deemGuard($event)" style="margin-top: 5px; margin-left: 5%;">
<p style="padding-bottom:20px">This plans protects your Wallet, Mobile phones and Card against any fraudulent misuse / transactions.
  It has benifits like medical reimbursement, hospital stay allowance and entitles you for (Base Product Proposition to Be Added).
  All this for a nominal fee. Click here to know more.
</p>
<p style="padding-bottom:50px;color:#9E9E9E">View Fees & Charges ></p>
<p style="padding-bottom:20px">
                <button
                  class="buttonClass2"
                  id="linkButton"
                  @click.prevent="moveToAddress()"
                >
                 SUBMIT
                </button>
              </p>
            </div>
          </div>
        </FieldsetModel>
      </div>
      <div v-if="appiontmentText==='Personal_Loan' || isScreenChoice==='loan'">
       <FieldsetModel :ui="uiBaseFieldset" name="fieldsetInsuranceLoan" ui-title="">
          <div class="container">
            <div class="step2-col1 margin-top" style="max-width:400px;" >
              <p class="p1-insurance">Insure your Personal Loan & be Sure</p> 
             <p class="p2-insurance">To opt in for one or both the insurance please click on the box and hit "SUBMIT"</p>
              <!-- <p class="p1-insurance">Insure your Credit  Card & be Sure</p>
              
             <p class="p2-insurance">To opt in for one or both the insurance please click on the box and hit "SUBMIT"</p> -->
            </div>
            <div class="step2-col2" style="max-width:400px" >
         <p style="font-weight:bold;padding-bottom:20px;display:inline-block;margin-right:10px;">Deem Credit Life Plus</p>
             <input type="checkbox" class="largerCheckbox" id="chkDoubleSecure" name="chkDoubleSecure" @change.prevent="doubleSecure($event)" style="color: #6E3DEA;margin-left: 5%;">
             <p style="display:inline-block;padding-bottom:20px">The plans protects your loan outstanding in the unfortunate event of death
             or terminal illness. It also provisions for repatriation expenses to country of origin. All this for a 
             nominal fee. Click here to know more.

             </p>
             <p style="padding-bottom:50px;color:#9E9E9E">View Fees & Charges ></p>
<p style="font-weight:bold;padding-bottom:20px;display:inline-block;margin-right:10px;">Deem Loan Protect</p>
 <input type="checkbox" class="largerCheckbox" id="chkGuard" name="chkGuard" @change.prevent="deemGuard($event)" style="margin-left: 5%;">
<p style="padding-bottom:20px">The plans provisions for a financial corpse to be provided as multiple of 
principle loan amount in the event of accidental death or disability. It has benifits like school fee cover 
for 2 years, travel insurance benifits and entitles you for(Base Product Proposition to Be Added). All this 
for a nominal fee. Click here to know more.
</p>
<p style="padding-bottom:50px;color:#9E9E9E">View Fees & Charges ></p>
<p style="padding-bottom:20px">
                <button
                  class="buttonClass2"
                  id="linkButton"
                  @click.prevent="moveToAddress()"
                >
                 SUBMIT
                </button>
              </p>
            </div>
          </div>
        </FieldsetModel>
        </div>
      </StepModel>
      <!-- <StepModel
    :ui="uiBaseStep"
    :name="STEP_NAMES.appointmentDigital"
    ui-title=""
    ui-subtitle=""
    ui-error-message="Please review the fields marked in red"
    ui-button-text="Submit"
  >
 
  <FieldsetModel :ui="uiBaseFieldset" name="fieldSetAppointmentDigital2" >
      <p style=" color: #6e3dea;
  font-weight: 500;
  font-size: 30px;padding-bottom:10px">Congratulations</p>
  <p style="font-weight: 500;font-size: 15px">{{this.isApprovedLimit}}</p>
  </FieldsetModel>
  
    <FieldsetModel :ui="uiBaseFieldset" :name="name" ui-columns="2" ui-title="Where would you like your card delivered?">
          <UiWrapper
            :name="FIELD_NAMES.addressLine1"
            label="Address Line 1"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.addressLine2"
            label="Address Line 2"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper :name="FIELD_NAMES.residentialEmirate" label="Emirate" optional>
            <Dropdown placeholder="Emirate" :options="EMIRATE_LIST_CARD" />
          </UiWrapper>
          <UiWrapper :name="FIELD_NAMES.homeCountryCountry" label="Country" optional>
            <Suggest
              :exact-match="true"
              placeholder="Country"
              :get-formatted-item="formatMatchedString"
              :get-suggestions="getCountriesAppointment"
            />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.homeCountryPoscode"
            label="PO Box"
            optional
            :validations="pinCodeValidations"
          >
            <InputText />
          </UiWrapper>
    </FieldsetModel>

  </StepModel> -->
    
     <StepModel
        :ui="uiBaseStep"
        :name="STEP_NAMES.continue"
        ui-title=" "
        ui-subtitle=" "
        ui-hide-button
      >
         <!-- <FieldsetModel :ui="uiBaseFieldset" name="fieldSetStep2" ui-title="" >
        
      </FieldsetModel> -->
        <FieldsetModel :ui="uiBaseFieldset" name="fieldSetContinue" ui-title="">
          
          <p style="
            padding-bottom: 30px;
            text-align: center;
            color: #6e3dea;
            font-weight: 500;
            font-size: 30px;
          ">Please be with us while we review your application. This will only take a few moments</p>
         <p><img class="center" src="/img/assets/card/World - Cash Up.png" width="250px" height="150px" /></p>

        
           
        </FieldsetModel>
   
      </StepModel>
      <!-- <StepModel
        :ui="uiBaseStep"
        name="rewardstype-step"
        ui-title=" "
        ui-subtitle=" "
        ui-error-message="Please review the fields marked in red"
        ui-hide-button
      >
        <FieldsetModel
          :ui="uiBaseFieldset"
          name="rewardstype"
          ui-title="What kind of rewards would you like?"
        >
          <UiWrapper :name="FIELD_NAMES.rewards" next-step-on-change>
            <Choice :options="REWARDSTYPE" />
          </UiWrapper>
        </FieldsetModel>
      </StepModel> -->

      <!-- <StepModel
        :ui="uiBaseStep"
        name="income-step"
        ui-title=" "
        ui-subtitle=" "
        ui-error-message="Please review the fields marked in red"
        ui-hide-button
        :custom-flow="[
          {
            condition: () => fieldValues(FIELD_NAMES.income) === 'Less than AED 10,000',
            goTo: 'show-cards',
          },
          {
            condition: () => fieldValues(FIELD_NAMES.income) === 'AED 10,000 - AED 25,000',
            goTo: 'use-step',
          },
          {
            condition: () => fieldValues(FIELD_NAMES.income) === 'More than AED 25,000',
            goTo: 'uselong-step',
          }
        ]"
      >
        <FieldsetModel
          :ui="uiBaseFieldset"
          name="income"
          ui-title="What is your fixed monthly income?"
        >
          <UiWrapper :name="FIELD_NAMES.income" next-step-on-change>
            <Choice :options="INCOME" :columns="3" />
          </UiWrapper>
        </FieldsetModel>
      </StepModel>

      <StepModel
        :ui="uiBaseStep"
        name="use-step"
        ui-title=" "
        ui-subtitle=" "
        ui-error-message="Please review the fields marked in red"
        ui-hide-button
      >
        <FieldsetModel :ui="uiBaseFieldset" name="use" ui-title="What are you going to use it for?">
          <UiWrapper :after-change="finishNBC" :name="FIELD_NAMES.use">
            <Choice :options="CARD_USE" :columns="2" />
          </UiWrapper>
        </FieldsetModel>
      </StepModel>

      <StepModel
        :ui="uiBaseStep"
        name="uselong-step"
        ui-title=" "
        ui-subtitle=" "
        ui-error-message="Please review the fields marked in red"
        ui-hide-button
      >
        <FieldsetModel
          :ui="uiBaseFieldset"
          name="uselong"
          ui-title="What are you going to use it for the most?"
        >
          <UiWrapper :after-change="finishNBC" :name="FIELD_NAMES.uselong">
            <Choice :options="CARD_USE_LONG" :columns="3" />
          </UiWrapper>
        </FieldsetModel>
      </StepModel>

      <StepModel :ui="uiBaseStep" name="show-cards" ui-title=" " ui-subtitle=" " ui-hide-button>
        <FieldsetModel :ui="uiBaseFieldset" name="empty-show-cards" ui-title>
          <span />
        </FieldsetModel>
      </StepModel>
     -->
    </MainForm>
    <!-- <NBCSuggestions :show="showFilters">
      <template v-slot:header>
        <span v-html="dynamicRecommendation">{{ dynamicRecommendation }}</span>
      </template>
      <template v-slot:suggestions>
        <div v-for="(product, key) in getFilteredSuggestions" :key="key">
          <ProductCover
            :key="key"
            :image="product.image"
            :title="product.title"
            :label="showBest(key, product.best)"
            :features="product.features"
          >
            <template v-slot:btn-left v-if="canApply">
              <Button
                width="full"
                size="md"
                :click="actionWrapper(goToForm, product.onboarding_form,product.title)"
              >Apply</Button>
            </template>
          </ProductCover>
        </div>
      </template>
    </NBCSuggestions> -->

    <!-- <div v-for="(product, key) in getFilteredSuggestions" :key="key" class="side-panels">
      <SidePanel
        :legend="product.benefits.legend"
        :title="product.benefits.title"
        :show="isPanelVisible(key)"
        :on-close="() => { hidePanel() }"
      >
        <Grid>
          <div
            v-for="(item, itemKey) in product.benefits.items"
            :key="itemKey"
            class="grid-cell"
            data-width-xs="12"
            data-width-md="6"
          >
            <PlainText>
              <img :src="item.image" />
              <div class="regular-big" v-html="item.title" />
              <div class="regular-medium">{{ item.content }}</div>
            </PlainText>
          </div>
        </Grid>
      </SidePanel>
    </div> -->
  
  </div>
</template>
<script>
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import STEP_NAMES from "@/forms/constants/step-names";
// Ui Wrappers
import UiWrapper from "@/forms/components/base/ui-wrapper";
import FieldsetEmiratesIdNumber from "@/forms/components/shared/fieldsets/emirates-id-number";
import StepOtp from "@/forms/components/cards/credit-card-digital/steps/otp";

import StepOCREmirates from "@/forms/components/cards/credit-card-digital/steps/ocr-emirates";
import IdentityReview from "@/forms/components/cards/credit-card-digital/steps/identity-review";
import FieldsetIBAN from "@/forms/components/cards/stp-card/steps/fieldsets/iban-number";
import flowManager from "@/lib/services/flow-manager";
import FieldIncome from "@/forms/components/shared/fields/income";
// Ui Components
import {
  InputText,
  InputSlide,
  Choice,
  Suggest,
  Dropdown,
  InputPassword,
  Expandable,
  Button,
  ProductCover,
  SidePanel,
  Grid,
  NBCSuggestions,
  Card,
} from "@dunia/ui";

// Utils
import CheckWrapper from "@/forms/components/ui-dunia/check-wrapper";
import getLastEditValue from "@/forms/helpers/get-last-edit-value";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import Vue from "vue";

import * as conditions from "@/forms/conditions";
import { patternCondition } from "@/forms/conditions";
// Services
import bankPerfioService from "@/forms/api/services/bank-perfio";
import uploadService from "@/forms/api/services/upload";
import promoCodeService from "@/forms/api/services/validate-promo-code";
// Constants
import { MIN_FIXED_INCOME } from "@/forms/constants/onboarding-logic";
import FIELD_NAMES from "@/forms/constants/field-names";

import FieldsetEmail from "@/forms/components/shared/fieldsets/email";

import FieldsetMobilePhone from "@/forms/components/shared/fieldsets/mobile-phone";
import FieldsetFullName from "@/forms/components/shared/fieldsets/full-name";

import getValueByFieldName from "@/forms/helpers/get-value-by-field-name";
import formService from "@/forms/api/services/form";
import sendGAEvent from "@/forms/helpers/ga-events";
import routeManager from "@/router";
import {
  SPENDING,
  YESNO,
  INCOME,
  CARD_USE,
  CARD_USE_LONG,
  REWARDSTYPE,
  FEATURES_NBC_CARDS,
  //FIELD_NAMES
} from "@/forms/constants/nbc-logic";
import {
 
  SET_PRODUCT_TYPE,
  SET_CARD_TYPE,
  SET_INELIGIBLE_EMIRATES,
  SET_EMPLOYMENT_TYPE,
  SET_PROMO_CODE_RESPONSE,
  SET_PROMO_CODE_STATUS,
  SET_INELIGIBLE_MEDIUM_OF_RECEIVE,
  SET_VARIABLE_INCOME,
  SET_UAE_VINTAGE,
  SET_DEEMGUARD_CREDITLIFEPLUS,
  SET_DEEM_DOUBLESECURE_LOANPROTECT
} from "@/lib/constants/mutations";
import {
  DIGIT_CHARS,
  ADDRESS_CHARS,
  DECISION_FORM_MAP,
} from "@/forms/constants/onboarding-logic";
import { parse } from "path";
//Store
import store from "@/store";
import { type } from "os";
import { watch } from "fs";

export default {
  name: "OnboardDunia",
  mixins: [FormComponentMixin],
  components: {
    //Components
    MainForm,
    StepModel,
    FieldsetModel,
    Dropdown,
    Choice,
    Suggest,
    InputText,
    InputSlide,
    UiWrapper,
    FieldsetEmail,
    FieldsetMobilePhone,
    FieldsetFullName,
    CheckWrapper,
    Button,
    Expandable,
    FieldsetEmiratesIdNumber,
    StepOtp,
    IdentityReview,
    StepOCREmirates,
    FieldsetIBAN,
    ProductCover,
    SidePanel,
    Grid,
    NBCSuggestions,
    Card,
    FieldIncome,
  },

  data: () => ({
    panelVisible: -1,
    ___readyToAnimate: false,
    SPENDING,
    YESNO,
    INCOME,
    CARD_USE,
    CARD_USE_LONG,
    REWARDSTYPE,
    FEATURES_NBC_CARDS,
    FIELD_NAMES,
    firstTitle:
      "A six digit OTP has been sent to your registered mobile number (",
    mobileNumber: "050 xxx xx80" + ")",
    monthlyIncome: 26000,
    appiontmentText: "",
    keyBenifitsTitanium: false,
    keyBenifitsPlatinum: false,
    keyBenifitsWorld: false,
    viewMore: true,
    insuranceBlockA: "",
    insuranceBlockB: "",
    //currentSteps:""
  }),
  props: {
    addressValidations: {
      type: Array,
      default: () => [
        {
          errorMessage:
            "Field contains invalid characters. Albhabets, Numbers and special character (- , / space) are allowed.",
          condition: patternCondition(ADDRESS_CHARS),
          name: "address-chars",
        },
      ],
    },
    pinCodeValidations: {
      type: Array,
      default: () => [
        {
          errorMessage: "Field contains invalid characters.",
          condition: patternCondition(DIGIT_CHARS),
          name: "pincode-chars",
        },
      ],
    },
  },
  mounted() {
    this.___readyToAnimate = true;
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
  updated() {
     var step=this.$store.state.formData.currentStepName;
    //   console.log('currentSteps='+currentSteps);
    //this.monthlyIncome=this.$store.state.medium;
    console.log('currentStep='+step)
    if(step===this.STEP_NAMES.loan)
    {
      store.commit(SET_PRODUCT_TYPE, { productType: "Personal_Loan" });
   
    }
    else if(step===this.STEP_NAMES.creditCard)
    {
      store.commit(SET_PRODUCT_TYPE, { productType: "Credit Card" });
    }
  },
  computed: {
    showFilters() {
      const { values } = this.$store.state.formData;

      const spending = getValueByFieldName(values, FIELD_NAMES.spending);
      const rewards = getValueByFieldName(values, FIELD_NAMES.rewards);

      return (
        this.___readyToAnimate &&
        (spending === "Paying straight away" || rewards !== null)
      );
    },

    canApply() {
      const { values } = this.$store.state.formData;

      const spending = getValueByFieldName(values, FIELD_NAMES.spending);
      const income = getValueByFieldName(values, FIELD_NAMES.income);

      if (spending === "Paying straight away" || income !== null) {
        return true;
      }
      return false;
    },

    getFilteredSuggestions() {
      const { values } = this.$store.state.formData;

      const spending = getValueByFieldName(values, FIELD_NAMES.spending);
      const rewards = getValueByFieldName(values, FIELD_NAMES.rewards);
      const income = "More than AED 25,000"; //getValueByFieldName(values, FIELD_NAMES.income);
      const use = getValueByFieldName(values, FIELD_NAMES.use);
      const uselong = getValueByFieldName(values, FIELD_NAMES.uselong);

      return FEATURES_NBC_CARDS.filter((el, key) => {
        console.log(el);
        console.log("key" + key);
        // if (key === 0) {
        //   // stored value card
        //   return spending === "Paying straight away";
        // }
        //  if (key === 1) {
        //   // world miles card
        //   if (
        //     (rewards === "Miles Up for travel rewards" && income === null) ||
        //     (rewards === "Miles Up for travel rewards" &&
        //       income === "More than AED 25,000" &&
        //       uselong === null) ||
        //     (rewards === "Miles Up for travel rewards" &&
        //       income === "More than AED 25,000" &&
        //       uselong === "Travel")
        //   ) {
        //     return true;
        //   }
        // }

        // if (key === 1) {
        // world miles card
        if (income === "More than AED 25,000") {
          return true;
        }
        // }
        // if (key === 2) {
        //   // platinum miles card
        //   if (
        //     (rewards === "Miles Up for travel rewards" && income === null) ||
        //     (rewards === "Miles Up for travel rewards" &&
        //       income === "AED 10,000 - AED 25,000" &&
        //       use === null) ||
        //     (rewards === "Miles Up for travel rewards" &&
        //       income === "AED 10,000 - AED 25,000" &&
        //       use === "Shopping and Lifestyle") ||
        //     (rewards === "Miles Up for travel rewards" &&
        //       income === "More than AED 25,000" &&
        //       uselong === null) ||
        //     (rewards === "Miles Up for travel rewards" &&
        //       income === "More than AED 25,000" &&
        //       uselong === "Shopping and Lifestyle")
        //   ) {
        //     return true;
        //   }
        // }
        // if (key === 3) {
        //   // titanium miles card
        //   if (
        //     (rewards === "Miles Up for travel rewards" && income === null) ||
        //     (rewards === "Miles Up for travel rewards" &&
        //       income === "Less than AED 10,000") ||
        //     (rewards === "Miles Up for travel rewards" &&
        //       income === "AED 10,000 - AED 25,000" &&
        //       use === null) ||
        //     (rewards === "Miles Up for travel rewards" &&
        //       income === "AED 10,000 - AED 25,000" &&
        //       use === "Everyday spend") ||
        //     (rewards === "Miles Up for travel rewards" &&
        //       income === "More than AED 25,000" &&
        //       uselong === null) ||
        //     (rewards === "Miles Up for travel rewards" &&
        //       income === "More than AED 25,000" &&
        //       uselong === "Everyday spend")
        //   ) {
        //     return true;
        //   }
        // }
        // if (key === 4) {
        //   // world cashpoints card
        //   if (
        //     (rewards === "Cash Up for cashback" && income === null) ||
        //     (rewards === "Cash Up for cashback" &&
        //       income === "More than AED 25,000" &&
        //       uselong === null) ||
        //     (rewards === "Cash Up for cashback" &&
        //       income === "More than AED 25,000" &&
        //       uselong === "Travel")
        //   ) {
        //     return true;
        //   }
        // }
        // if (key === 5) {
        //   // platinum cashpoints card
        //   if (
        //     (rewards === "Cash Up for cashback" && income === null) ||
        //     (rewards === "Cash Up for cashback" &&
        //       income === "AED 10,000 - AED 25,000" &&
        //       use === null) ||
        //     (rewards === "Cash Up for cashback" &&
        //       income === "AED 10,000 - AED 25,000" &&
        //       use === "Shopping and Lifestyle") ||
        //     (rewards === "Cash Up for cashback" &&
        //       income === "More than AED 25,000" &&
        //       uselong === null) ||
        //     (rewards === "Cash Up for cashback" &&
        //       income === "More than AED 25,000" &&
        //       uselong === "Shopping and Lifestyle")
        //   ) {
        //     return true;
        //   }
        // }
        // if (key === 6) {
        //   // titanium cashpoints card
        //   if (
        //     (rewards === "Cash Up for cashback" && income === null) ||
        //     (rewards === "Cash Up for cashback" &&
        //       income === "Less than AED 10,000") ||
        //     (rewards === "Cash Up for cashback" &&
        //       income === "AED 10,000 - AED 25,000" &&
        //       use === null) ||
        //     (rewards === "Cash Up for cashback" &&
        //       income === "AED 10,000 - AED 25,000" &&
        //       use === "Everyday spend") ||
        //     (rewards === "Cash Up for cashback" &&
        //       income === "More than AED 25,000" &&
        //       uselong === null) ||
        //     (rewards === "Cash Up for cashback" &&
        //       income === "More than AED 25,000" &&
        //       uselong === "Everyday spend")
        //   ) {
        //     return true;
        //   }
        // }

        return false;
      });
    },

    dynamicRecommendation() {
      const { values } = this.$store.state.formData;

      const spending = getValueByFieldName(values, FIELD_NAMES.spending);
      const salary = getValueByFieldName(values, FIELD_NAMES.salary);
      const rewards = getValueByFieldName(values, FIELD_NAMES.rewards);
      const income = getValueByFieldName(values, FIELD_NAMES.income);
      const use = getValueByFieldName(values, FIELD_NAMES.use);
      const uselong = getValueByFieldName(values, FIELD_NAMES.uselong);

      let r1 = "";
      let r2 = "";
      let r3 = "";
      let r4 = "";

      r1 = "A <strong>Credit card</strong>";

      if (rewards === "Miles Up for travel rewards") {
        r2 = " for <strong>Miles Up</strong>";
      }
      if (
        rewards === "Miles Up for travel rewards" &&
        income === "Less than AED 10,000"
      ) {
        r2 =
          " for <strong>Miles Up</strong>" +
          " and a <strong>salary less than AED 10K</strong>";
      }
      if (
        rewards === "Miles Up for travel rewards" &&
        income === "AED 10,000 - AED 25,000" &&
        use === "Shopping and Lifestyle"
      ) {
        r2 =
          " for <strong>Miles Up</strong>" +
          " and a <strong>salary between AED 10K - 25K</strong>" +
          " for <strong>shopping and lifestyle</strong>";
      }
      if (
        rewards === "Miles Up for travel rewards" &&
        income === "More than AED 25,000" &&
        uselong === "Shopping and Lifestyle"
      ) {
        r2 =
          " for <strong>Miles Up</strong>" +
          " and a <strong>salary of more than AED 25K</strong>" +
          " for <strong>shopping and lifestyle</strong>";
      }

      if (
        rewards === "Miles Up for travel rewards" &&
        income === "AED 10,000 - AED 25,000" &&
        use === "Everyday spend"
      ) {
        r2 =
          " for <strong>Miles Up</strong>" +
          " and a <strong>salary between AED 10K - 25K</strong>" +
          " for <strong>everyday spend</strong>";
      }
      if (
        rewards === "Miles Up for travel rewards" &&
        income === "More than AED 25,000" &&
        uselong === "Everyday spend"
      ) {
        r2 =
          " for <strong>Miles Up</strong>" +
          " and a <strong>salary of more than AED 25K</strong>" +
          " for <strong>everyday spend</strong>";
      }

      if (
        rewards === "Miles Up for travel rewards" &&
        income === "More than AED 25,000" &&
        uselong === "Travel"
      ) {
        r2 =
          " for <strong>Miles Up</strong>" +
          " and a <strong>salary of more than AED 25K</strong>" +
          " for <strong>travel</strong>";
      }
      ////casback
      if (rewards === "Cash Up for cashback") {
        r2 = " for <strong>Cash Up</strong>";
      }
      if (
        rewards === "Cash Up for cashback" &&
        income === "Less than AED 10,000"
      ) {
        r2 =
          " for <strong>Cash Up</strong>" +
          " and a <strong>salary less than AED 10K</strong>";
      }
      if (
        rewards === "Cash Up for cashback" &&
        income === "AED 10,000 - AED 25,000" &&
        use === "Shopping and Lifestyle"
      ) {
        r2 =
          " for <strong>Cash Up</strong>" +
          " and a <strong>salary between AED 10K - 25K</strong>" +
          " for <strong>shopping and lifestyle</strong>";
      }

      if (
        rewards === "Cash Up for cashback" &&
        income === "More than AED 25,000" &&
        uselong === "Shopping and Lifestyle"
      ) {
        r2 =
          " for <strong>Cash Up</strong>" +
          " and a <strong>salary of more than AED 25K</strong>" +
          " for <strong>shopping and lifestyle</strong>";
      }

      if (
        rewards === "Cash Up for cashback" &&
        income === "AED 10,000 - AED 25,000" &&
        use === "Everyday spend"
      ) {
        r2 =
          " for <strong>Cash Up</strong>" +
          " and a <strong>salary between AED 10K - 25K</strong>" +
          " for <strong>everyday spend</strong>";
      }

      if (
        rewards === "Cash Up for cashback" &&
        income === "More than AED 25,000" &&
        uselong === "Everyday spend"
      ) {
        r2 =
          " for <strong>Cash Up</strong>" +
          " and a <strong>salary of more than AED 25K</strong>" +
          " for <strong>everyday spend</strong>";
      }
      if (
        rewards === "Cash Up for cashback" &&
        income === "More than AED 25,000" &&
        uselong === "Travel"
      ) {
        r2 =
          " for <strong>Cash Up</strong>" +
          " and a <strong>salary of more than AED 25K</strong>" +
          " for <strong>travel</strong>";
      }

      return `${r1}${r2}`;
    },

    hasNBCFinished() {
      return flowManager.currentStepName === "show-cards";
    },
    isSalesAgent() {
      return this.$store.state.employeeCodes;
    },
    isMonthlyIncomeSource() {
      if (this.$store.state.medium) {
        this.monthlyIncome = this.$store.state.medium;
        return this.monthlyIncome;
      }
      return this.monthlyIncome;
    },
    isAppointmentText() {
      if (this.appiontmentText === "Personal_Loan") {
        return `Your Loan is almost done.`;
      } else {
        return `Your Credit Card is almost there.`;
      }
    },
    isApprovedLimit() {
      if (this.appiontmentText === "Personal_Loan") {
        return `You are approved for a Deem Personal Loan for AED 50,000.`;
      } else {
        return `You are approved for a Deem Credit Card with a limit of AED 10,000.`;
      }
    },
    isScreenChoice() {
      if (this.$store.state.source) {
        return this.$store.state.source;
      }
    },
    isSalaried() {
      return this.fieldValues(FIELD_NAMES.employmentType) === "Salaried";
    },
    isSelfEmployed() {
      return this.fieldValues(FIELD_NAMES.employmentType) === "Self-employed";
    },
    isCurrentStep() {
     
      return this.$store.state.formData.currentStepName;
    },
  },
  methods: {
    finishNBC() {
      flowManager.goToNextStep({ stepToGo: "show-cards" });
    },

    actionWrapper(cb, ...args) {
      return () => cb(...args);
    },

    fieldValues(fieldname) {
      const { $store } = this;

      return getValueByFieldName($store.state.formData.values, fieldname);
    },

    // benefits panel logic
    isPanelVisible(key) {
      return key === this.panelVisible;
    },

    showPanel(key) {
      this.panelVisible = key;
    },

    hidePanel() {
      this.panelVisible = -1;
    },

    showBest(key, label) {
      if (key === 0) {
        return label;
      }
      return null;
    },
    gotToWelcome(callback) {
      var product = this.fieldValues(FIELD_NAMES.product);
      var formToGo = "";
      if (product) {
        if (product.toLowerCase() === "personal loan".toLowerCase()) {
          formToGo = "Deem | Loan Application";
        } else if (product.toLowerCase() === "credit card") {
          formToGo = "Deem | Credit Card Application";
        }
      }

      callback();
      if (formToGo != "") {
        router.goToFormByName(formToGo, {
          stepNameToInit: stepToGo,
        });
      }
    },
    applyPromo() {
      alert("");
    },
    moveToSecondStep() {
      flowManager.goToNextStep({
        //stepToGo: this.STEP_NAMES.digitalChoice,
        stepToGo: this.STEP_NAMES.otpVerificationDigital,
        skipValidations: true,
      });
    },
    liked(product) {
      var source = this.$store.state.source;
      if (product === "Personal_Loan") {
        store.commit(SET_PRODUCT_TYPE, { productType: "Personal_Loan" });
        this.insuranceBlockA = `<p class="p1-insurance">Insure your Personal Loan & be Sure</p> 
             <p class="p2-insurance">To opt in for one or both the insurance please click on the box and hit "SUBMIT"</p>`;
        this.insuranceBlockB = `<p style="font-weight:bold;padding-bottom:20px;display:inline-block;margin-right:10px;">Deem Credit Life Plus</p>
             <input type="checkbox" class="largerCheckbox" id="chkDoubleSecure" name="chkDoubleSecure" @change.prevent="doubleSecure($event)" style="color: #6E3DEA;margin-left: 5%;">
             <p style="display:inline-block;padding-bottom:20px">The plans protects your loan outstanding in the unfortunate event of death
             or terminal illness. It also provisions for repatriation expenses to country of origin. All this for a 
             nominal fee. Click here to know more.

             </p>
             <p style="padding-bottom:50px;color:#9E9E9E">View Fees & Charges ></p>
<p style="font-weight:bold;padding-bottom:20px;display:inline-block;margin-right:10px;">Deem Loan Protect</p>
 <input type="checkbox" class="largerCheckbox" id="chkGuard" name="chkGuard" @change.prevent="deemGuard($event)" style="margin-left: 5%;">
<p style="padding-bottom:20px">The plans provisions for a financial corpse to be provided as multiple of 
principle loan amount in the event of accidental death or disability. It has benifits like school fee cover 
for 2 years, travel insurance benifits and entitles you for(Base Product Proposition to Be Added). All this 
for a nominal fee. Click here to know more.
</p>
<p style="padding-bottom:50px;color:#9E9E9E">View Fees & Charges ></p>
<p style="padding-bottom:20px">
                <button
                  class="buttonClass2"
                  id="linkButton"
                  @click.prevent="moveToAddress()"
                >
                 SUBMIT
                </button>
              </p>`;
        this.appiontmentText = "Personal_Loan";
        flowManager.goToNextStep({
          stepToGo: this.STEP_NAMES.loan,
          skipValidations: true,
        });
      } else {
        store.commit(SET_PRODUCT_TYPE, { productType: "Credit Card" });
        this.insuranceBlockA = `<p class="p1-insurance">Insure your Credit  Card & be Sure</p> 
             <p class="p2-insurance">To opt in for one or both the insurance please click on the box and hit "SUBMIT"</p>`;
        this.insuranceBlockB = `<p style="font-weight:bold;padding-bottom:20px;display:inline-block;margin-right:10px;">Deem Double Secure</p>
             <input type="checkbox" class="largerCheckbox" id="chkDoubleSecure" name="chkDoubleSecure" @change.prevent="doubleSecure($event)" style="margin-top: 5px; color: #6E3DEA;margin-left: 5%;">
             <p style="display:inline-block;padding-bottom:20px">The plans covers your credit card outstanding in the event of involuntary loss of employment.
                It pays double in the unfortunate event of critical illness or accidental death and also extends 
                benifits like Ambulance/Taxi Fare & per day hospital cash payouts. All this for a nominal fee. Click here to know more.

             </p>
             <p style="padding-bottom:50px;color:#9E9E9E">View Fees & Charges ></p>
<p style="font-weight:bold;padding-bottom:20px;display:inline-block;margin-right:10px;">Deem Guard</p>
 <input type="checkbox" class="largerCheckbox" id="chkGuard" name="chkGuard" @change.prevent="deemGuard($event)" style="margin-top: 5px; margin-left: 5%;">
<p style="padding-bottom:20px">This plans protects your Wallet, Mobile phones and Card against any fraudulent misuse / transactions.
  It has benifits like medical reimbursement, hospital stay allowance and entitles you for (Base Product Proposition to Be Added).
  All this for a nominal fee. Click here to know more.
</p>
<p style="padding-bottom:50px;color:#9E9E9E">View Fees & Charges ></p>
<p style="padding-bottom:20px">
                <button
                  class="buttonClass2"
                  id="linkButton"
                  @click.prevent="moveToAddress()"
                >
                 SUBMIT
                </button>
              </p>`;
        this.appiontmentText = "Credit Card";
        flowManager.goToNextStep({
          stepToGo: this.STEP_NAMES.creditCard,
          skipValidations: true,
        });
      }
    },
    async apply(cardType) {
      store.commit(SET_CARD_TYPE, { cardType: cardType });
      // const spinner = document.getElementById("spinner");
      // spinner.removeAttribute("hidden");
      await formService.sendFormWithoutBlock();
      //spinner.setAttribute("hidden", "");
      flowManager.goToNextStep({
        stepToGo: this.STEP_NAMES.uploadIdentityDigital,
        skipValidations: true,
      });
    },
    async moveToAddress() {
      var currentStep = store.state.formData.currentStepName;
      sendGAEvent(currentStep, "PROGRESS");
      routeManager.goToFormByName(
        DECISION_FORM_MAP[routeManager.currentFormName]["PROGRESS"]
      );
    },
    viewMoreCard() {
      if (this.monthlyIncome > 25000 && this.viewMore === true) {
        this.viewMore = false;
      } else if (
        this.monthlyIncome >= 10000 &&
        this.monthlyIncome <= 25000 &&
        this.viewMore === true
      ) {
        this.viewMore = false;
      } else if (
        this.monthlyIncome >= 5000 &&
        this.monthlyIncome <= 10000 &&
        this.viewMore === true
      ) {
        this.viewMore = false;
      } else {
        this.viewMore = true;
      }
    },
    viewLessCard() {
      if (this.monthlyIncome > 25000 && this.viewMore === false) {
        this.viewMore = true;
      } else if (
        this.monthlyIncome >= 10000 &&
        this.monthlyIncome <= 25000 &&
        this.viewMore === false
      ) {
        this.viewMore = true;
      } else if (
        this.monthlyIncome >= 5000 &&
        this.monthlyIncome <= 10000 &&
        this.viewMore === false
      ) {
        this.viewMore = true;
      } else {
        this.viewMore = false;
      }
    },
    doubleSecure(event) {
      console.log(event.target.checked);
      if(event.target.checked)
      {
        store.commit(SET_DEEM_DOUBLESECURE_LOANPROTECT,{deemDoubleSecureLoanProtect:'Y'})
        console.log('doubles secure='+this.$store.state.deemDoubleSecureLoanProtect);
      }
       else{
        store.commit(SET_DEEM_DOUBLESECURE_LOANPROTECT,{deemDoubleSecureLoanProtect:'N'})
      }
    },
    deemGuard(event) {
      console.log(event.target.checked);
      if(event.target.checked)
      {
        store.commit(SET_DEEMGUARD_CREDITLIFEPLUS,{deemGuardCreditLife:'Y'})
      }
      else{
        store.commit(SET_DEEMGUARD_CREDITLIFEPLUS,{deemGuardCreditLife:'N'})
      }
    },
    // finishCallback() {
    //   this.showEndPage({
    //     title: "Thank you for your application!",
    //     subtitle: "Our team will get back to you shortly.",
    //   });
    // },
  },
};
</script>

<style >
.c-onboarding > .header .content > .title {
  font-family: "Moderat", serif;
  font-weight: 300;
  font-size: 15px;
  line-height: 28px;
  letter-spacing: 0px;
  color: #000;
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 72px;
  padding: 0 0 0 0 !important;
}
div#app
  div#abc
  div.root-form
  form.c-onboarding
  div.header
  div.cr-wrapper
  div.content
  div.title {
  padding: 0 0 0 0;
}
/* .c-step {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 100%;
    max-height: 600%;
    min-height: calc(100vh - 72px);
    padding: 36px 0 28px 0;
} */
.c-step > .header {
  position: relative !important;
  width: 100% !important;
  padding-bottom: 0px !important;
}
.c-progressbar {
  position: relative !important;
  width: 0 !important;
  height: 0;
  background-color: white !important;
}

.step-alignment {
  top: 30px;
}
.p1 {
  padding-bottom: 20px;
  text-align: center;
  color: #6e3dea;
  font-weight: 500;
  font-size: 30px;
}
.p2 {
  text-align: center;
  padding-bottom: 20px;
  font-size: 20px;
  font-weight: 500;
}
.p1-insurance {
  padding-bottom: 20px;

  color: #6e3dea;
  font-weight: 500;
  font-size: 30px;
}
.p2-insurance {
  padding-bottom: 20px;
  font-size: 20px;
  font-weight: 500;
}
.p3 {
  padding-left: 36%;
}
.choiceTitle1 {
  padding-bottom: 10px;
  font-size: 20px;
  font-weight: 500;
  word-wrap: break-word;
  width: 300px;
}
.buttonClass {
  width: auto;
  height: 40px;
  color: white;
  display: block;
  margin-top: 0;
  text-align: center;
  border-radius: 0;
  margin-left: 30px;
  font-size: 12px;
  background: #6e3dea !important;
  padding-left: 8px;
  padding-right: 8px;
  text-transform: uppercase;
  cursor: pointer;
}
.buttonClass2 {
  width: auto;
  height: 30px;
  color: white;
  display: block;
  margin-top: 0;
  text-align: center;
  border-radius: 0;
  /* margin-left: 30px; */
  font-size: 12px;
  background: #6e3dea !important;
  padding-left: 20px;
  padding-right: 20px;
  text-transform: uppercase;
  cursor: pointer;
}
.grid-container {
  display: grid;
  grid-template-columns: auto auto;

  padding: 10px;
}
.grid-item {
  padding: 20px;
  font-size: 30px;
  /* text-align: center; */
}

.container {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 768px) {
  .container {
    width: 750px;
  }
}

@media (min-width: 992px) {
  .container {
    width: 970px;
  }
}

@media (min-width: 1200px) {
  .container {
    width: 1170px;
  }
}

.container .col p {
  padding: 0.25rem 0.75rem;
}

/* 2 columns (600px) */

@media only screen and (min-width: 600px) {
  .container .col {
    float: left;
    width: 50%;
  }
}

/* 3 columns (768px) */

@media only screen and (min-width: 768px) {
  .container .col {
    width: 33.333%;
  }
}

/* 4 columns (992px) */

@media only screen and (min-width: 992px) {
  .container .col {
    width: 25%;
  }
}
@media (max-width: 768px) {
  #wrapper {
    grid-template-columns: 4fr;
  }
}

@media (min-width: 1281px) {
  #wrapper {
    grid-template-columns: 2fr 2fr;
  }
}
@media (max-width: 1279px) {
  #wrapper {
    grid-template-columns: 2fr 2fr;
  }
}
#wrapper {
  display: grid;
}

/** */

.step2-col1 {
  grid-column: span 6;
}
.step2-col2 {
  grid-column: span 6;
}

@media screen and (max-width: 768px) {
  .step2-col1 {
    grid-column: span 12;
  }
  .step2-col2 {
    grid-column: span 12;
  }
}
/**Step Card Choice 1  */
.container {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
}

.step3-col1 {
  grid-column: span 4;
}
.step3-col2 {
  grid-column: span 4;
}
.step3-col3 {
  grid-column: span 4;
}

ul.dashed {
  list-style-type: none;
  padding-top: 10px;
}
ul.dashed > li {
  text-indent: -5px;
}
ul.dashed > li:before {
  content: "- ";
  text-indent: -5px;
}
@media screen and (max-width: 950px) {
  .step3-col1 {
    grid-column: span 12;
  }
  .step3-col2 {
    grid-column: span 12;
  }
  .step3-col3 {
    grid-column: span 12;
  }
}
@media (max-width: 768px) {
  [class="p3"] {
    padding-left: 20%;
  }
}

/* Progess Bar with steps */
.stepper-wrapper {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}

.stepper-item::before {
  margin-top: 30px;
  position: absolute;
  content: "";
  border-bottom: 3px solid #ccc;
  width: 100%;
  top: 15px;
  left: -50%;
  z-index: 2;
}

.stepper-item::after {
  margin-top: 30px;
  position: absolute;
  content: "";
  border-bottom: 3px solid #ccc;
  width: 100%;
  top: 15px;
  left: 50%;
  z-index: 2;
}

.stepper-item .step-counter {
  margin-top: 30px;
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
}

.stepper-item.active {
  font-weight: bold;
}
.step-counter.active {
  background-color: #6e3dea;
}

.stepper-item.completed .step-counter {
  background-color: #6e3dea;
}

.stepper-item.completed::after {
  position: absolute;
  content: "";
  /* border-bottom: 2px solid #6e3dea; */
  width: 100%;
  top: 15px;
  left: 50%;
  z-index: 3;
}

.stepper-item:first-child::before {
  content: none;
}
.stepper-item:last-child::after {
  content: none;
}
.pointer {
  cursor: pointer;
}
li {
  word-wrap: break-word;
  width: 300px;
}
p.text-decoration {
  font-weight: bold;
}
p.text-decoration:hover {
  text-decoration: underline;
  cursor: pointer;
}

input.largerCheckbox {
  color: #6e3dea;
  width: 20px;
  height: 20px;
  background-color: brown;
}
.margin-top {
  margin-top: 30%;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
@media screen and (max-width: 950px) {
  .margin-top {
    margin-top: 0;
  }
}
@keyframes fadein {
  0% {
    opacity: 0;
  }
  66% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes fadein {
  0% {
    opacity: 0;
  }
  66% {
    opacity: 0.25;
  }
  100% {
    opacity: 1;
  }
}
@keyframes blink {
  /**
     * At the start of the animation the dot
     * has an opacity of .2
     */
  0% {
    opacity: 0.2;
  }
  /**
     * At 20% the dot is fully visible and
     * then fades out slowly
     */
  20% {
    opacity: 1;
  }
  /**
     * Until it reaches an opacity of .2 and
     * the animation can start again
     */
  100% {
    opacity: 0.2;
  }
}

.saving .dotAnimation {
  /**
     * Use the blink animation, which is defined above
     */
  animation-name: blink;
  /**
     * The animation should take 1.4 seconds
     */
  animation-duration: 0.5s;
  /**
     * It will repeat itself forever
     */
  animation-iteration-count: infinite;
  /**
     * This makes sure that the starting style (opacity: .2)
     * of the animation is applied before the animation starts.
     * Otherwise we would see a short flash or would have
     * to set the default styling of the dots to the same
     * as the animation. Same applies for the ending styles.
     */

  animation-fill-mode: both;
}

.dot {
  animation-name: blink;
  /**
     * The animation should take 1.4 seconds
     */
  animation-duration: 0.5s;
  /**
     * It will repeat itself forever
     */
  animation-iteration-count: infinite;
  height: 8px;
  width: 8px;
  background-color: #000000;
  border-radius: 50%;
  display: inline-block;
  margin-right: 15px;
}
.dotText {
  font-family: "Moderat", serif;
  font-weight: 300;
  font-size: 15px;
  color: #9e9e9e;
}
</style>